const ModalHelper = {
    init: () => {
        // $('[data-toggle="modal"]').click(function() {
        //     $($(this).data('target')).removeClass('hidden');

        //     return false;
        // });

        // $('[data-dismiss="modal"]').click(function() {
        //     $('.modal').addClass('hidden');
        // });
    },
}

Object.freeze(ModalHelper);

export default ModalHelper;


// WEBPACK FOOTER //
// ./scripts/components/ModalHelper.js